module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    //
                }
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
